import { ProjectorScreen } from "@phosphor-icons/react";

/** The labeled projection toggle: "Project on Screen" ↔ "Stop Showing". */
export function ProjectToggle({ onAir, canProject, onProject, onStop, variant = "label", disabled = false }: {
  onAir: boolean;
  canProject: boolean;
  onProject: () => void;
  onStop: () => void;
  variant?: "label" | "icon";
  disabled?: boolean;
}) {
  if (variant === "icon") {
    return onAir ? (
      <button
        type="button"
        className="btn icon thread-action-project is-onair"
        data-testid="thread-project-btn"
        aria-label="Stop showing on projector"
        title="Stop showing on projector"
        disabled={disabled}
        onClick={onStop}
      >
        <ProjectorScreen weight="fill" />
      </button>
    ) : (
      <button
        type="button"
        className="btn icon thread-action-project"
        data-testid="thread-project-btn"
        aria-label="Project on screen"
        title="Project on screen"
        disabled={disabled || !canProject}
        onClick={onProject}
      >
        <ProjectorScreen weight="bold" />
      </button>
    );
  }

  return onAir ? (
    <button type="button" className="btn onair sm" data-testid="thread-project-btn" disabled={disabled} onClick={onStop}>
      <ProjectorScreen weight="fill" /> Stop Showing
    </button>
  ) : (
    <button type="button" className="btn primary sm" data-testid="thread-project-btn" disabled={disabled || !canProject} onClick={onProject}>
      <ProjectorScreen weight="bold" /> Project on Screen
    </button>
  );
}
